import { render, staticRenderFns } from "./CoreSelectCurrency.vue?vue&type=template&id=0a6bc7a5"
import script from "./CoreSelectCurrency.vue?vue&type=script&lang=js"
export * from "./CoreSelectCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports